import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconModule, KeyboardFocusModule } from '@spartacus/storefront';
import { I18nModule, UrlModule } from '@spartacus/core';
import { RouterModule } from '@angular/router';
import { HisenseFacetComponent } from './facet.component';

@NgModule({
  declarations: [HisenseFacetComponent],
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    I18nModule,
    IconModule,
    KeyboardFocusModule,
  ],
  exports: [HisenseFacetComponent],
})
export class HisenseFacetModule {}
